import { DealEventStatus } from '@dealstack/shared/lib/backendClient';
import { Flex, Text } from '@mantine/core';
import { useTheme } from 'styled-components';
import { StatusDotIcon } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/StatusDotIcon/StatusDotIcon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import {
	getStatusColor,
	getStatusLabel,
} from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogStatus.utils.ts';

interface Props {
	status: DealEventStatus;
}

export const DealEventStatusCell = ({ status }: Props) => {
	const tCapManage = useTranslationCapManage();
	const theme = useTheme();
	const color = getStatusColor(status, theme);

	return (
		<Flex align="center" gap="0.4rem" w="100%">
			<StatusDotIcon color={color} />

			<Text size="sm" c={color}>
				{getStatusLabel(status, tCapManage)}
			</Text>
		</Flex>
	);
};
